import { buildAddOnField } from "../add-on-field";

export function createDatapointPicker(schemaFormProvider, sfPathProvider) {
	return function datapointPicker(name, schema, options) {
		if(schema.type !== "datapoint" || schema.format !== "datapoint") {
			return undefined;
		}

		const field = buildAddOnField(
			schemaFormProvider,
			sfPathProvider,
			name,
			schema,
			options,
			"datapoint",
			"./template.html"
		);
		field.schema = schema.type === schema.format
			? { ...schema, type: "number" }
			: schema;

		return field;
	};
}

export function datapointAddOn(
	schemaFormDecoratorsProvider,
	sfBuilderProvider,
	schemaFormProvider,
	sfPathProvider
) {
	const picker = createDatapointPicker(schemaFormProvider, sfPathProvider);

	schemaFormProvider.defaults.datapoint = [picker];

	schemaFormDecoratorsProvider.defineAddOn(
		"bootstrapDecorator",           	// Name of the decorator you want to add to.
		"datapoint",                      		// Form type that should render this add-on
		"./templates/datapoint/template.html",  		// Template name in $templateCache
		sfBuilderProvider.stdBuilders   	// List of builder functions to apply.
	);
}
